import { render, staticRenderFns } from "./studentProfile.vue?vue&type=template&id=16506acc&scoped=true&"
import script from "./studentProfile.vue?vue&type=script&lang=js&"
export * from "./studentProfile.vue?vue&type=script&lang=js&"
import style0 from "./studentProfile.vue?vue&type=style&index=0&id=16506acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16506acc",
  null
  
)

export default component.exports